module.exports = __webpack_public_path__ + "img/ios.38342cae.svg";